import Button from './Button';

// `children` renders in the middle of the bar (the school admin's global search).
export default function TopBar({ title, tierLabel, tier = 'transit', onLogout, children }) {
  const badgeTone = tier === 'clearance' ? 'bg-clearance-tint text-clearance-deep' : 'bg-transit-tint text-transit-deep';
  return (
    <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-line bg-paper-raised">
      <div className="flex items-center gap-3 min-w-0">
        <h1 className="font-display font-extrabold text-lg text-ink truncate">{title}</h1>
        {tierLabel && (
          <span className={`text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full font-body shrink-0 ${badgeTone}`}>
            {tierLabel}
          </span>
        )}
      </div>
      {children && <div className="flex-1 flex justify-center min-w-0">{children}</div>}
      <Button variant="secondary" onClick={onLogout} className="shrink-0">Logout</Button>
    </div>
  );
}
